///all in one
import axios from "@/axios";
export const businessType = [];

export const businessTypeGetters = {
  getBusinessType: state => {
    return state.businessType;
  }
};

export const businessTypeMutations = {
  changeBusinessType(state, value) {
    state.businessType = value;
  }
};

export const businessTypeActions = {
  act_loadBusinessType: async ({ commit }) => {
    let respone = await axios.get("type-buniness");
    commit("changeBusinessType", respone.data.data);
  }
};
